import axios from "axios";
import { Environment } from '../environments/Environment';

const baseUrl = Environment.baseUrl;
const userBaseUrl = baseUrl + "/admin/usermanagement";

export function getUsers(Status) {
  return (axios.post(userBaseUrl +"/User/"+ Status));
}

export function addUser(user) {
  return (axios.post(userBaseUrl + "/add", user));
}

export function addFulcrumUser(user) {
  return (axios.post(userBaseUrl + "/AddFulcrumUser", user));
}

export function updateUser(user) {
  return (axios.post(userBaseUrl + "/update", user));
}

export function userRoles(email) {
  return (axios.get(userBaseUrl + "/userroles/" + email));
}

export function resetUserPassword(user) {
  return (axios.post(userBaseUrl + "/resetpassword", user));
}

export function activateUser(user) {
  return (axios.post(userBaseUrl + "/activate", user));
}

export function deActivateUser(user) {
  return (axios.post(userBaseUrl + "/deactivate", user));
}

export function getUserRoles(email) {
  return (axios.get(userBaseUrl + "/roles/" + email));
}

export function updateUserRoles(email, roles) {
  return (axios.post(userBaseUrl + "/roles", { email: email, roles: roles }));
}